<ng-container *ngIf="currentAuthMethod$ | async as currentAuthMethod" [ngSwitch]="currentAuthMethod">
  <ng-container *ngSwitchCase="authMethods.ByCode">
    <sd-login-by-code-form></sd-login-by-code-form>
  </ng-container>

  <ng-container *ngSwitchCase="authMethods.ByPassword">
    <sd-login-by-password-form></sd-login-by-password-form>
  </ng-container>
</ng-container>
